import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from "@angular/core";
import moment from "moment";
import { Subscription } from "rxjs";
import { AppService } from "src/app/core/services/app.service";
import { FocusdataService } from "src/app/core/services/focusdata.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { ImageCropperService } from "src/app/core/services/image-cropper.service";
import { UserService } from "src/app/core/services/user.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { MenuItemRecord } from "src/app/shared/models/focusDataModels/MenuItemRecord";
import { OOMenuItem } from "src/app/shared/models/oo-menu-item";
import { OOMenuItemTags } from "src/app/shared/models/oo-menu-tags.model";

@Component({
	selector: "app-menu-item-detail",
	templateUrl: "./menu-item-detail.component.html",
	styleUrls: ["../../../../commandcenter.scss"],
})
export class MenuItemDetailComponent implements OnInit, OnDestroy {
	@Input() menuItemKey: number;
	@Output() unsavedChangesChange = new EventEmitter<boolean>();

	imageCropperSubscription = new Subscription();

	menuItem: OOMenuItem;
	menuItemRecord: MenuItemRecord;
	moment: any = moment;

	timestamp: number = new Date().getTime();

	constructor(
		public app: AppService,
		private focuslink: FocuslinkService,
		private focusdata: FocusdataService,
		public imgCrop: ImageCropperService,
		public venueService: OOVenueService,
		public userSvc: UserService
	) {}
	ngOnDestroy(): void {
		this.imageCropperSubscription.unsubscribe();
	}

	ngOnInit(): void {
		this.menuItem = this.venueService.ooMenuItems.find((i) => i.menuItemKey === this.menuItemKey);
		// this.venueService.subscriptionOOmenuItems.subscribe((item) => {
		// 	this.menuItem = item.find((i) => i.menuItemKey === this.menuItemKey);
		// });

		this.fdMenuItemGet(this.menuItemKey);
	}

	async fdMenuItemGet(menuItemKey: number) {
		const resp = await this.focusdata.configMenuItemGetOne(this.venueService.venueKey, menuItemKey);
		this.menuItemRecord = new MenuItemRecord(resp);
	}

	async ooMenuItemTagSelect(event, menuItemKey) {
		const itemIdx = this.venueService.ooMenuItems.findIndex((i) => i.menuItemKey === this.menuItemKey);
		if (!this.venueService.ooMenuItems[itemIdx].OOMenuItemTags) {
			this.venueService.ooMenuItems[itemIdx].OOMenuItemTags = [];
		}
		const tagIdx = this.venueService.ooMenuItems[itemIdx].OOMenuItemTags?.findIndex((i) => i.tagKey === event.value);
		if (tagIdx !== -1) {
			const tag = this.venueService.ooTags.find((i) => i.key === event.value);
			this.app.msgSvc.add({
				severity: "warn",
				summary: `${tag.name} is already on ${this.menuItem.name}`,
			});

			return;
		}

		const resp = await this.focuslink.menuItemTagPost(this.venueService.venueKey, menuItemKey, event.value);
		const tag = new OOMenuItemTags(resp);
		tag.OOTags = this.venueService.ooTags.find((i) => i.key === tag.tagKey);

		this.venueService.ooMenuItems[itemIdx].OOMenuItemTags
			? this.venueService.ooMenuItems[itemIdx].OOMenuItemTags.push(tag)
			: (this.venueService.ooMenuItems[itemIdx].OOMenuItemTags = [tag]);
		this.venueService.subscriptionOOmenuItems.next(this.venueService.ooMenuItems);

		return;
	}

	async ooMenuItemTagRemove(tagKey: string, menuItemKey: number) {
		//item removed
		await this.focuslink.menuItemTagDelete(this.venueService.venueKey, menuItemKey, tagKey);
		const tagKeyIdx = this.menuItem.OOMenuItemTags.findIndex((i) => i.tagKey === tagKey);
		if (tagKeyIdx !== -1) {
			this.menuItem.OOMenuItemTags.splice(tagKeyIdx, 1);
		}
	}

	async selectMenuItemImage(menuItemKey) {
		console.log(menuItemKey);
		console.log(this.menuItem);
		this.imgCrop.openImageCropper("menuitem", menuItemKey, this.venueService.venueKey);
		this.imageCropperSubscription.add(
			this.imgCrop.imageCroppingComplete.subscribe((data) => {
				this.saveMenuItemImage();
			})
		);
	}

	async saveMenuItemImage() {
		this.app.delay(1000);
		this.menuItem.imageKey = `${this.menuItemKey}.png`;
		this.timestamp = new Date().getTime();
	}

	async menuItemImageDelete(rec: OOMenuItem) {
		this.app.confirmation.confirm({
			message: `Are you sure you want to delete the picture from ${rec.displayName || rec.name}`,
			accept: async () => {
				this.focuslink.menuItemImageDelete(this.venueService.venueKey, rec.menuItemKey);
				this.menuItem.imageKey = undefined;
			},
			reject: async () => {
				this.app.confirmation.close();
			},
		});
	}
}
